import PropTypes from 'prop-types'
import React from 'react'
import { useInView } from 'react-intersection-observer'
import { ThemeContext } from 'styled-components'

import HowToBlock from 'components/_special/HowToBlock'
import List from 'components/List'
import RenderInView from 'components/RenderInView'
import { REGION_JP } from 'constants/regions'
import { ResizeContext } from 'contexts/Resize'
import { Col, Row } from 'styles/components/layout'
import { Text } from 'styles/components/typography'

import BHowRetestChart from './components/BHowRetestChart'
import { Wrapper, ChartWrapper, BoxBaseStyled, RowStyled } from './styles'

const chart_version = REGION_JP === process.env.region ? '_150921' : ''

const BHowRetest = ({ index, data, isSquareHidden, cdnPath }) => {
  const { tablet, mobile } = React.useContext(ResizeContext)
  const [ref, inView] = useInView({
    threshold: 1,
    rootMargin: mobile ? '0% 0px' : '-10% 0px',
    triggerOnce: true,
  })
  const { colors } = React.useContext(ThemeContext)

  return (
    <BoxBaseStyled>
      <div style={{ position: 'relative' }}>
        <HowToBlock
          isSquareHidden={isSquareHidden}
          title={data.title}
          index={index}
          squareColor={colors.grass}
          lineColor="light"
          textColor="light"
          isLast
        >
          <RowStyled>
            <Col
              width={{
                xs: 1,
                md: 8 / 12,
                lg: 4 / 12,
              }}
            >
              <Text
                className="with-inverted-links"
                dangerouslySetInnerHTML={{ __html: data.content }}
              />
            </Col>
          </RowStyled>
          <Row flexDirection="column">
            <Col
              width={{
                xs: 1,
                md: 4 / 12,
                lg: 4 / 12,
              }}
            >
              <List leftAlignment="text" textColor="white">
                {data.list.map(item => (
                  <List.Item key={item} bulletColor="white">
                    {item}
                  </List.Item>
                ))}
              </List>
            </Col>
            <RenderInView display="block">
              <Col
                width={{
                  xs: 1,
                  md: 8 / 12,
                  lg: 8 / 12,
                }}
              >
                <Wrapper ref={ref}>
                  <ChartWrapper>
                    {inView && (
                      <BHowRetestChart
                        isMobile={mobile}
                        isDesktop={!mobile && !tablet}
                        data={data}
                      />
                    )}
                  </ChartWrapper>
                  {!tablet && !mobile && (
                    <img
                      width="auto"
                      height="100%"
                      src={`${cdnPath}/retest/chart${chart_version}.svg`}
                      alt="chart"
                    />
                  )}
                  {tablet && (
                    <img
                      width="auto"
                      height="100%"
                      src={`${cdnPath}/retest/chart${chart_version}_tablet.svg`}
                      alt="chart tablet"
                    />
                  )}
                  {mobile && (
                    <img
                      width="auto"
                      height="100%"
                      src={`${cdnPath}/retest/chart${chart_version}_mob.svg`}
                      alt="chart mobile"
                    />
                  )}
                </Wrapper>
              </Col>
            </RenderInView>
          </Row>
        </HowToBlock>
      </div>
    </BoxBaseStyled>
  )
}

BHowRetest.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  locale: PropTypes.string.isRequired,
  cdnPath: PropTypes.string.isRequired,
  isSquareHidden: PropTypes.bool,
}

BHowRetest.defaultProps = {
  isSquareHidden: false,
}

export default BHowRetest
